import AwsBody from './awsBody';
import DigitalOceanBody from './digitalOceanBody';
import GCPBody from './gcpBody';
import TencentBody from './tencent/tencentBody';

interface props{
    id:string
    cloud:string
}
const AddCloudBody = ({ id, cloud }:props) => {
  const setView = () => {
    if (cloud.toLowerCase() === 'aws') {
      return <AwsBody id={id} />;
    }
    if (cloud.toLowerCase() === 'digitalocean') {
      return <DigitalOceanBody id={id} />;
    }
    if (cloud.toLocaleLowerCase() === 'gcp') {
      return <GCPBody id={id} />;
    }

    if (cloud.toLowerCase() === 'tencent') {
      return <TencentBody id={id} />;
    }
    return <div>Cloud Not Supported</div>;
  };
  return (
        <div>
            {setView()}
        </div>
  );
};
export default AddCloudBody;